'use strict'

const VariantQuery = `
    availableChannels
    availableQuantity
    atpQuantity
    maxQuantity
    backorderQuantity
    backorderedAvailableDate
    benefits {
      benefits
      youTubeVideoId
      image {
        url
        alt
        thumbnail
      }
    }
    brandFamily
    channels
    chargeShipping
    customerTypes
    dangerousGoods
    description
    disclaimers
    disclaimerWarnings {
      icon {
        url
        alt
        thumbnail
      }
      markdown
    }
    excludeFromSearch
    faqs {
      question
      answers
    }
    features {
      image {
        url
        alt
        thumbnail
      }
      subtitle
      features
      backgroundColor
      textColor
    }
    foreignOrderLimit
    globalId
    id
    ingredients {
      keyIngredients {
        name
        description
        image {
          url
          alt
          thumbnail
        }
      }
      nutritionInformationImage {
        url
        alt
        thumbnail
      }
      productName
      allIngredients
      otherIngredients
      
      inactiveIngredients
      ingredientDisclaimers
      markdown
    }
    isExclusive
    marketAttributes {
      discount
      redeem
      earn
    }
    matchingVariant
    nettoWeight
    orderType
    points {
      wholesale {
        cv
        pv
        sb
      }
      subscription {
        cv
        pv
        sb
      }
      original {
        cv
        pv
        sb
      }
    }
    price {
      currencyCode
      retail
      wholesale
      retailSales
      wholesaleSales
      retailSubscription
      wholesaleSubscription
      retailOriginal
      wholesaleOriginal
    }
    totalPoints {
      wholesale {
        cv
        pv
        sb
      }
      subscription {
        cv
        pv
        sb
      }
      original {
        cv
        pv
        sb
      }
    }
    totalPrice {
      currencyCode
      retail
      wholesale
      retailSales
      wholesaleSales
      retailSubscription
      wholesaleSubscription
      retailOriginal
      wholesaleOriginal
    }
    pricingJson
    primaryBrand
    productDetails {
      description
      includedItems
      highlights {
        iconUrl
        label
      }
      originCountry
      importer
      warnings
    }
    productImages {
      url
      alt
      thumbnail
    }
    productType
    purchaseTypes {
      buyOnce
      subscription
    }
    resources {
      title
      url
      image {
        url
        alt
        thumbnail
      }
    }
    restrictedMarkets
    results {
      summary
      results {
        percentage
        text
      }
      report {
        url
        text
      }
      youTubeVideoId
      image {
        url
        alt
        thumbnail
      }
    }
    salesDisclaimer
    salesLabel
    salesText
    scanQualifiedCount
    searchKeywords
    shadeable
    size
    sku
    slug
    status {
      status
      inventory
    }
    title
    usage {
      steps
      recommendations
      warnings
      additionalText
      youTubeVideoId
      image {
        url
        alt
        thumbnail
      }
      markdown
    }
    variantColor
    variantLabel
  `;

const BundleProduct = `
  type
  price {
    currencyCode
    retail
    wholesale
    retailSales
    wholesaleSales
    retailSubscription
    wholesaleSubscription
    retailOriginal
    wholesaleOriginal
  }
  pricingJson
  points {
    wholesale {
      cv
      pv
      sb
    }
    subscription {
      cv
      pv
      sb
    }
    original {
      cv
      pv
      sb
    }
  }
  parentId
  retailDiscount
  wholesaleDiscount
  pvDiscount
  cvDiscount
  sbDiscount
  grpDiscount
  availableChannels
  customerTypes
  purchaseTypes {
    buyOnce
    subscription
  }
  status {
    status
    inventory
  }
  availableQuantity
  atpQuantity
  maxQuantity
  backorderQuantity
  backorderedAvailableDate
  chargeShipping
  dangerousGoods
  excludeFromSearch
  isExclusive
  marketAttributes {
    discount
    redeem
    earn
  }
  restrictedMarkets
  scanQualifiedCount
  kitProducts {
    quantity
    isMandatory
    product {
      id
      variants {
        ${VariantQuery}
      }
    }
  }
`;

const ProductQuery = `
    id
    slug
    variantSelectLabel
    title
    productImages {
      url
      alt
      thumbnail
    }
    salesLabel
    salesText
    description
    salesDisclaimer
    features {
      image {
        url
        alt
        thumbnail
      }
      subtitle
      features
      backgroundColor
      textColor
    }
    productDetails {
      description
      includedItems
      highlights {
        iconUrl
        label
      }
      originCountry
      importer
      warnings
    }
    benefits {
      benefits
      youTubeVideoId
      image {
        url
        alt
        thumbnail
      }
    }
    results {
      summary
      results {
        percentage
        text
      }
      report {
        url
        text
      }
      youTubeVideoId
      image {
        url
        alt
        thumbnail
      }
    }
    sustainability {
      youTubeVideoId
      description
      highlights {
        description
        image {
          url
          alt
          thumbnail
        }
      }
      image {
        url
        alt
        thumbnail
      }
    }
    usage {
      steps
      recommendations
      warnings
      additionalText
      youTubeVideoId
      image {
        url
        alt
        thumbnail
      }
      markdown
    }
    resources {
      title
      url
      image {
        url
        alt
        thumbnail
      }
    }
    faqs {
      question
      answers
    }
    ingredients {
      keyIngredients {
        name
        description
        image {
          url
          alt
          thumbnail
        }
      }
      nutritionInformationImage {
        url
        alt
        thumbnail
      }
      productName
      allIngredients
      otherIngredients
      activeIngredients
      inactiveIngredients
      ingredientDisclaimers
      markdown
    }
    disclaimers
    disclaimerWarnings {
      icon {
        url
        alt
        thumbnail
      }
      markdown
    }
    seoInformation {
      metaDescription
      metaTitle
      canonicalURL
      ogImage {
        url
        alt
        thumbnail
      }
    }
    refundPolicy
    shippingText
    thirdPartyScripts
    categories {
      displayName
      id
      subcategories {
        displayName
        id
      }
    }
    warranty
    secondaryTitle
    variants {
      ${VariantQuery}
    }
    bundle {
      ${BundleProduct}
    }
    productDataSource {
        source
        webBaseUrl
        apiBaseUrl
        storeId
    }
    error {
        name
        errors
        lines
        message
        status
    }
    relevancyRank
`;

const TranslationsQuery = `
  accounts {
    signIn
  }
  activeIngredients
  addToCartButton
  allIngredients
  benefitsAndKeyFeatures
  buyOnce
  cartToast {
    addedToCart
    viewCart
    failedAddToCart
  }
  countryOfOrigin
  description
  disclaimers
  error {
    name
    message
    status
    errors
    lines
  }
  exclusiveOffer {
    title
    message
    noQualification
    usedUpQty
    notAvailable
  }
  frequentlyAskedQuestions
  generalDisclaimer
  generic {
    back
    done
    enter
    select
    quantity
  }
  howToUseIt
  importer
  inactiveIngredients
  item
  keyIngredients
  loyalty {
    message
    linkText
    linkUrl
  }
  maxQuantityExceeded
  nettoWeight
  nutritionFacts
  otherIngredients
  points {
    sv
    csv
    pv
    cv
  }
  price {
    retail
    wholesale
    subscription
    retailSales
    wholesaleSales
  }
  product
  productDetails
  provenResults
  recommendations
  refund {
    message
    linkText
    linkUrl
  }
  resources
  resourcesSubtitle
  selectPurchaseType
  selectVariant
  shipping {
    message
    boldText
  }
  similarProducts
  socialImpactAndSustainability
  status {
    outOfStock
    onBackorder
    reachedPurchaseLimit
    discontinued
    notReleasedForSale
    stopStatus
    notSoldSeperately
  }
  steps
  subscribe
  subscribeButton
  total
  viewReport
  warnings
  whatPowersIt
  whatsIncluded
  whyYoullLoveIt
  dataSource
  subscriptions {
    message
    triggerText
    modal {
      content {
        uid
        header
        body
      }
      footer
    }
  }
  kitAndOrBundle {
    thisKitContainsAmountItems
    moreDetailsOnTheProductPageHere
    addMoreToYourBundle
  }
`
const CategoryTranslationsQuery = `
  sortBy
  sortByPriceLowToHigh
  sortByPriceHightToLow
  showMore
  products
  sortbyatoz
  sortbyztoa
  sortbyfeatured
 `

const ProductsQuery = `
products {
  ${ProductQuery}
  variants {
    ${VariantQuery}
  }
  bundle {
    ${BundleProduct}
  }
}
`

module.exports = {
    VariantQuery,
    ProductQuery,
    TranslationsQuery,
    ProductsQuery,
    CategoryTranslationsQuery
}